export const STATISTICS_GET = `STATISTICS_GET`;
export const STATISTICS_GET_SUCCESS = `STATISTICS_GET_SUCCESS`;
export const STATISTICS_GET_FAILURE = `STATISTICS_GET_FAILURE`;
export const STATISTICS_GET_REQUEST = `STATISTICS_GET_REQUEST`;
